import { Moon, Sun } from 'lucide-react'
import { useFarbschema, type Farbschema } from '../../theme/farbschema'

const OPTIONEN: { wert: Farbschema; label: string; icon: typeof Sun }[] = [
  { wert: 'dunkel', label: 'Dunkel', icon: Moon },
  { wert: 'hell', label: 'Hell', icon: Sun },
]

/**
 * Abschnitt „Darstellung“ für die Einstellungsseiten der Module: Dunkel/Hell als Auswahl.
 * Die Wahl gilt je Benutzer in allen Modulen und auf allen Geräten.
 */
export function FarbschemaWahl({ className = '' }: { className?: string }) {
  const [schema, setSchema] = useFarbschema()
  return (
    <section className={`card ${className}`} aria-labelledby="farbschema-titel" data-testid="farbschema-wahl">
      <h2 id="farbschema-titel" className="text-base font-semibold text-dark-text">Darstellung</h2>
      <p className="mt-1 text-sm text-dark-text-muted">
        Hell ist bei Sonnenlicht besser lesbar, Dunkel schont die Augen bei Nacht. Die Wahl gilt für Ihr Benutzerkonto in allen Modulen und auf allen Geräten.
      </p>
      <div role="radiogroup" aria-label="Farbschema" className="mt-3 inline-flex flex-wrap gap-2">
        {OPTIONEN.map(o => {
          const aktiv = schema === o.wert
          const Icon = o.icon
          return (
            <button
              key={o.wert}
              type="button"
              role="radio"
              aria-checked={aktiv}
              onClick={() => setSchema(o.wert)}
              className={`inline-flex min-h-[44px] items-center gap-2 rounded-lg border px-4 text-sm font-medium transition-colors ${
                aktiv ? 'border-primary-500 bg-primary-500/15 text-dark-text' : 'border-dark-border bg-dark-bg-tertiary text-dark-text-muted hover:text-dark-text'}`}
            >
              <Icon className="h-[18px] w-[18px]" aria-hidden="true" />
              {o.label}
            </button>
          )
        })}
      </div>
    </section>
  )
}
